/* Snippets - With GLightbox
/* ---------------------------------------------------------- */

import Prism from 'prismjs'

// Langages
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-typescript';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-bash';

// Plugins
import 'prismjs/plugins/toolbar/prism-toolbar';
import 'prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard';
//import 'prismjs/plugins/line-numbers/prism-line-numbers';

// CSS Prism
//import 'prismjs/themes/prism-okaidia.css';
import 'prismjs/themes/prism-tomorrow.css';
import 'prismjs/plugins/toolbar/prism-toolbar.css';
//import 'prismjs/plugins/line-numbers/prism-line-numbers.css';

export default function setupSnippets () {
    Prism.highlightAll()
    console.log('prismjs loaded')
}